export default __webpack_public_path__ + "static/media/fireFN15.736e7409.svg";